import image4 from "../../assets/images/undraw_logic_re_nyb4.svg";

export const homeObjFour = {
  lightBg: false,
  imgStart: "start",
  lightText: true,
  lightTopLine: true,
  topLine: "marketing agency",
  description:
    "We help business owners increase their revenue. Our Team of unique specialist can help you achieve your business goals",
  primary: true,
  lightTextDesc: true,
  headline: "lead generation specialist for online business",
  buttonLabel: "Get started",
  start: "true",
  alt: "Image",
  img: image4,
};
